import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
    CircularProgress
} from '@mui/material';
import memberService from '../services/memberService';
import { toast } from 'react-toastify';

const InviteMemberModal = ({ open, onClose, hostAccountId, onInvited }) => {
    const [emails, setEmails] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Parse emails from string (comma, space, newline separated)
        const emailList = emails
            .split(/[\s,]+/)
            .map(e => e.trim())
            .filter(e => e.length > 0);

        if (emailList.length === 0) {
            toast.error('Vui lòng nhập ít nhất một email');
            return;
        }

        setLoading(true);
        try {
            await memberService.inviteMembers(hostAccountId, emailList);
            toast.success(`Đã gửi lời mời tới ${emailList.length} thành viên`);
            setEmails('');
            onInvited();
            onClose();
        } catch (error) {
            toast.error(error.response?.data?.message || 'Mời thành viên thất bại');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={!loading ? onClose : undefined} maxWidth="sm" fullWidth>
            <DialogTitle>Mời Thành Viên</DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent>
                    <Typography variant="body2" color="text.secondary" paragraph>
                        Nhập địa chỉ email, phân tách bằng dấu phẩy, khoảng trắng hoặc xuống dòng.
                    </Typography>
                    <TextField
                        multiline
                        rows={6}
                        fullWidth
                        placeholder="user1@example.com, user2@example.com"
                        value={emails}
                        onChange={(e) => setEmails(e.target.value)}
                        disabled={loading}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} disabled={loading}>Hủy</Button>
                    <Button type="submit" variant="contained" disabled={loading} startIcon={loading && <CircularProgress size={20} />}>
                        {loading ? 'Đang gửi...' : 'Gửi lời mời'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default InviteMemberModal;
